const PHONE_DIGIT_COUNT = 11

export const formatPhone = (rawValue: string): string => {
  const digits = rawValue.replace(/\D/g, '').slice(0, PHONE_DIGIT_COUNT)
  if (!digits) return ''

  const { length } = digits

  let masked = `(${digits.slice(0, 2)}`
  if (length > 2) masked += `) ${digits.slice(2, 6)}`
  if (length > 6) masked += `-${digits.slice(6, 11)}`
  if (length === PHONE_DIGIT_COUNT) masked = `${masked.slice(0, 6)}${digits.slice(3, 7)}-${digits.slice(7, 11)}`

  return masked
}
